import React from "react";
import { useTranslation } from "react-i18next";
import { SubscriptionUseCaseEnum } from "../common/constants/SubscriptionUseCaseEnum";

export const UnsubscribeDescripition = ({
    data,
    subscription,
    config,
    channel
}) => {
    const { t } = useTranslation();

    const getSpecificDescription = () => {
        return (
            <>
                <p className="mdc-typography mdc-typography--subtitle1 fs-20 pr-1rem"
                    dangerouslySetInnerHTML={{
                        __html: t(`home.unsubscribeUseCase.${data.useCase}`, {
                            email: subscription.email,
                            organizationName: config.organizationName
                        })
                    }}
                />
            </>
        );
    };

    if (data.entityType === 'channel' && channel) {
        return (
            <>
                <p className="mdc-typography mdc-typography--subtitle1 fs-20 pr-1rem"
                    dangerouslySetInnerHTML={{
                        __html: t(`home.unsubscribeUseCase.Channel`, {
                            email: subscription.email,
                            organizationName: config.organizationName,
                            channel
                        })
                    }}
                />
            </>
        );
    }

    if (data.entityType === 'event') {
        return (
            <>
                <p className="mdc-typography mdc-typography--subtitle1 fs-20 pr-1rem"
                    dangerouslySetInnerHTML={{
                        __html: t(`home.unsubscribeUseCase.Event`, {
                            email: subscription.email,
                            organizationName: config.organizationName,
                            event: subscription.entityName
                        })
                    }}
                />
            </>
        );
    }

    if (Object.keys(SubscriptionUseCaseEnum).includes(data?.useCase)) {
        return getSpecificDescription();
    }

    // TODO: Define a general description?
    return (
        <></>
    );
}





